import { ActionList as ReactActionList } from "@certn/cascadia-react/components/action-list/ActionList";
import { memo } from "react";

import { CascadiaActionListProps } from "./types";

export const ActionList = memo(function (props: CascadiaActionListProps) {
  return <ReactActionList showDividers={true} hideBorder={false} {...props} />;
});
